"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _config = require("./../config");

var _moment = _interopRequireDefault(require("moment"));

/**
 * AuthUploadHelper
 *
 * Steps needed to post a file to our fileService
 * - should retrieve an auth key from endpoint
 * - send the key to our auth endpoint
 *
 * We can then post files to our file endpoint
 */
// TODO: We need to save the token
// it should expire every hour
// We need to get the expiry date from the token
var AuthUploadHelper = function AuthUploadHelper() {
  var _this = this;

  (0, _classCallCheck2["default"])(this, AuthUploadHelper);
  this.checkAuth =
  /*#__PURE__*/
  (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (_this.expiryDate) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", _this.retrieveAuthToken());

          case 2:
            if (!_this.isExpired()) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", _this.retrieveAuthToken());

          case 4:
            return _context.abrupt("return", _this.token);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  this.isExpired = function () {
    return _this.expiryDate && _this.expiryDate <= (0, _moment["default"])().unix();
  };

  this.retrieveAuthToken =
  /*#__PURE__*/
  (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2() {
    var url, options, apiKey, response;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "".concat(_this.tokenUrl, "/v1.0/token/imageservice");
            options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              credentials: 'include'
            };

            if (_this.authToken) {
              if (_this.useBearerAuth) {
                options.headers.Authorization = "Bearer ".concat(_this.authToken);
              } else {
                options.headers['X-CSRF-TOKEN'] = "".concat(_this.authToken);
              }
            }

            _context2.next = 5;
            return (0, _isomorphicFetch["default"])(url, options);

          case 5:
            apiKey = _context2.sent;
            _context2.next = 8;
            return apiKey.json();

          case 8:
            response = _context2.sent;
            // AuthUploadHelper.token = response.jwt
            _this.token = response.jwt;
            _this.expiryDate = _this.getExpiryDate(response.jwt);
            return _context2.abrupt("return", _this.token);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  this.decodeToken = function (token) {
    var decoded = (0, _jwtDecode["default"])(token);
    return decoded;
  };

  this.getExpiryDate = function (token) {
    if (token) {
      var _this$decodeToken = _this.decodeToken(token),
          expiryDate = _this$decodeToken.exp;

      if (expiryDate) {
        return expiryDate;
      }

      return null;
    }
  };

  this.getTokenEndpoint = function (product) {
    return _config.tokenUrls[product];
  };

  this.getTokenUploadEndpoint = function () {
    var tokenUrl = _this.tokenUrl,
        appendPath = _this.appendPath;
    return "".concat(tokenUrl).concat(appendPath);
  };

  this.token = null; // this is the token from the token/me call

  this.authToken = null;
  this.tokenUrl = null;
  this.product = null;
  this.appendPath = '/v1.0/token/imageservice';
  this.expiryDate = null;
  this.useBearerAuth = false;
};

var _default = new AuthUploadHelper();

exports["default"] = _default;